import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import DeviceDetails from "./DeviceDetails";
import history from "../../auth/history";
import { store } from "../../redux/store";
import { resetMiscData, setAepsShow, setBankLogoList, setBillPayShow, setClaimLoadShow, setClientRole, setDeviceInfo, setDMTShow, setKycShow, setLoginTimestamp, setLogoName, setMiscCallBackUrl, setPartner, setPayoutShow, setRechargeShow, setRequesterId, setRetailerBlanceShow, setTaLoadPermission, setTimeoutModal } from "../../redux/misc-data/misc-data.action";
import { setToken } from './../../redux/misc-data/misc-data.action';
import { setAgentInfo } from './../../redux/misc-data/misc-data.action';
import { setCallBackUrl } from "../../redux/auth/auth.action";
import { resetBillPayData } from "../../redux/billpayDetails/billpay.action";
import { resetAeps, setAepsSection } from "../../redux/aeps/aeps.action";
import { resetRecharge } from "../../redux/recharge/recharge.action";
import { resetRetailerKyc, setROId } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";
import tokenErrorHandler from "../tokenErrorHandler";
import { resetOrderId } from "../../redux/order-details/order-details.action";
import { resetPayoutType } from "../../redux/payout/payout.action";

const httpClient = axios.create();
class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            otpRef: '',
            message: ''
        }
    }

    componentDidMount() {



        store.dispatch(resetMiscData);
        store.dispatch(resetBillPayData);
        store.dispatch(resetRecharge);
        store.dispatch(resetRetailerKyc);
        store.dispatch(resetAeps);
        store.dispatch(resetOrderId);
        store.dispatch(resetPayoutType);

        localStorage.clear();

        console.log('login request...');
        // store.dispatch(setAepsSection('txnHistory'));

        var query = window.location.search.substring(1);

        query = query.replace("/whitelabel", "");
        query = query.replace("/login", "");

        var emitraUrl = query.split("?")[0];
        var emitraParameters = query.split("?")[0];

        var vars = emitraParameters.split("&");
        console.log(vars);

        var encData = "";
        var partner = "";
        var service = '';

        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            console.log("pair: " + pair);
            if (pair[0] == "encData" || pair[0] == "encdata") {
                encData = pair[1];
            }
            console.log("encData=" + encData);
            if (pair[0] == "partner" || pair[0] == "partner") {
                partner = pair[1];
            }
            if (pair[0] == "partner" || pair[0] == "partner") {
                partner = pair[1];
            }
            console.log("partner=" + partner);
            if (pair[0] == "service" || pair[0] == "service") {
                service = pair[1];
            }
            console.log("service=" + service);
        }


        var requesterId = '';
        var logo = '';
        var role = '';
        var taLoad = '';
        var retailerBalanceShowVal = '';
        var claimLoadShowVal = '';
        var timeoutModal = '';
        var showBillPayMenu = '';
        var showRecharge = '';
        var showPayout = '';
        var showAepsMenu = '';
        var showDMT = '';
        var showKyc = '';


        var partners = process.env.REACT_APP_PARTNER;
        var requesterIds = process.env.REACT_APP_REQUESTERID;
        var logos = process.env.REACT_APP_LOGO;
        var roles = process.env.REACT_APP_ROLE;
        var taLoadPermission = process.env.REACT_APP_TALOAD;
        var retailerBalanceShow = process.env.REACT_APP_RETAILER_BALANCE;
        var claimLoadShow = process.env.REACT_APP_CLAIM_LOAD;
        var timeoutModals = process.env.REACT_APP_TIMEOUT_MODAL;
        var showBillPayMenus = process.env.REACT_APP_SHOW_BILLPAY;
        var showRechargeMenus = process.env.REACT_APP_SHOW_RECHARGE;
        var showPayoutMenus = process.env.REACT_APP_SHOW_PAYOUT;
        var showAepsMenus = process.env.REACT_APP_SHOW_AEPS;
        var showDMTMenus = process.env.REACT_APP_SHOW_DMT;
        var showKycMenus = process.env.REACT_APP_SHOW_KYC;



        var partnerList = partners.split(',');
        var requesterIdList = requesterIds.split(',');
        var logoList = logos.split(',');
        var roleList = roles.split(',');
        var taLoadList = taLoadPermission.split(',');
        var retailerBalanceShowList = retailerBalanceShow.split(',');
        var claimLoadShowList = claimLoadShow.split(',');
        var timeoutModalList = timeoutModals.split(',');
        var showBillPayMenulist = showBillPayMenus.split(',');
        var showRechargeMenuList = showRechargeMenus.split(',');
        var showPayoutMenuList = showPayoutMenus.split(',');
        var aepsMenuList = showAepsMenus.split(',');
        var dmtMenuList = showDMTMenus.split(',');
        var kycMenuList = showKycMenus.split(',');

        var indexVal = partnerList.indexOf(partner.toLowerCase());

        requesterId = requesterIdList[indexVal];
        logo = logoList[indexVal];
        role = roleList[indexVal];
        taLoad = taLoadList[indexVal];
        retailerBalanceShowVal = retailerBalanceShowList[indexVal];
        claimLoadShowVal = claimLoadShowList[indexVal];
        timeoutModal = timeoutModalList[indexVal];
        showBillPayMenu = showBillPayMenulist[indexVal];
        showRecharge = showRechargeMenuList[indexVal];
        showPayout = showPayoutMenuList[indexVal];
        showAepsMenu = aepsMenuList[indexVal];
        showDMT = dmtMenuList[indexVal];
        showKyc = kycMenuList[indexVal];


        const requestHeader = {
            msgType: "AUTHORIZE_WHITELABEL_USER",
            service: partner == 'emitra' ? "EMITRA" : partner == 'cms' ? 'CMS' :
                partner == 'finxpay' && 'FINXPAY',
            src: "login",
            dst: "dashboard",
            channel: "WHITELABEL",
            requesterId: requesterId,
            requestId: uuidv4(),//filled by the 3rd party requester
            time: moment().utc(),
            traceId: uuidv4(),
        }

        var authorizeRequest = "";



        navigator.geolocation.getCurrentPosition(function (position) {

            console.log("Latitude is :", position.coords.latitude);

            console.log("Longitude is :", position.coords.longitude);

            const deviceInfo = DeviceDetails.fetchDeviceInfo(position.coords.latitude,
                position.coords.longitude);
            deviceInfo.then((deviceResponse) => {
                store.dispatch(setDeviceInfo(deviceResponse));

                var partnerIdVal = process.env.REACT_APP_PARTNER_ID_ + partner;
                if (partnerIdVal.includes("undefined")) {
                    partnerIdVal = partnerIdVal.substring(9);
                }

                console.log("partnerIdVal", partnerIdVal);

                authorizeRequest = {
                    header: requestHeader,
                    device: deviceResponse,
                    // partnerId:partnerIdVal.trim(),
                    encData: encData

                }

                console.log('request::' + JSON.stringify(authorizeRequest));

                var url = '/api/v1/' + partner + '/user/auth';

                httpClient.post(url, authorizeRequest
                ).then((response) => {
                    console.log('login response' + JSON.stringify(response.data));

                    if (response.data.response.msg == 'SUCCESS') {

                        console.log('login time:', moment().format("DD-MM-YYYY hh:mm:ss"));

                        var token = response.data.token;
                        store.dispatch(setAgentInfo(response.data.agent));
                        store.dispatch(setToken(token));
                        store.dispatch(setRequesterId(requesterId));
                        store.dispatch(setLogoName(logo));
                        store.dispatch(setPartner(partner));
                        store.dispatch(setClientRole(role));
                        store.dispatch(setTaLoadPermission(taLoad));
                        store.dispatch(setClaimLoadShow(claimLoadShowVal));
                        store.dispatch(setRetailerBlanceShow(retailerBalanceShowVal));
                        store.dispatch(setTimeoutModal(timeoutModal));
                        store.dispatch(setBillPayShow(showBillPayMenu));
                        store.dispatch(setRechargeShow(showRecharge));
                        store.dispatch(setPayoutShow(showPayout));
                        store.dispatch(setAepsShow(showAepsMenu));
                        store.dispatch(setDMTShow(showDMT));
                        store.dispatch(setKycShow(showKyc));

                       


                        
                        if (
                            response.data.agent.status != null &&
                            response.data.agent.status != undefined &&
                            response.data.agent.status != '') {
                            if (response.data.agent.status == 'SYS_REGISTERED') {
                                store.dispatch(setROId(response.data.agent.internalRoId));
                            }
                        }
                        if (response.data.redirectUrl != undefined &&
                            response.data.redirectUrl != null &&
                            response.data.redirectUrl != '') {
                            store.dispatch(setCallBackUrl(response.data.redirectUrl));
                            store.dispatch(setMiscCallBackUrl(response.data.redirectUrl))
                        } else {
                            if (partner == 'cms') {
                                store.dispatch(setCallBackUrl('/cms-login'));
                                store.dispatch(setMiscCallBackUrl('/cms-login'));
                            }
                            if (partner == 'finxpay') {
                                store.dispatch(setCallBackUrl('/finxpay-login'));
                                store.dispatch(setMiscCallBackUrl('/finxpay-login'));
                            }
                        }


                        //upper case lower case name
                        store.dispatch(setLoginTimestamp(new Date()));
                        // this.readBanklLogo();
                        fetch(process.env.PUBLIC_URL + "/bank_images/bank_logo.txt")
                            .then(data => data.text())
                            .then(data => {
                                store.dispatch(setBankLogoList(data.toUpperCase()));

                                setTimeout(() => {

                                    if (partner == 'finxpay') {

                                        if (response.data.agent.status == null) {
                                            httpClient.post('/agipi/v1/finxpay/user/' + response.data.agent.id + '/assign/' + response.data.agent.id + '/SYS_REGISTERED'
                                                , '',

                                            ).then((response) => {
                                              
                                                    if (service == '') {
                                                        history.push('/dmt');
                                                        history.go();
                                                    }
                                                    if (service == 'dmt') {
                                                        history.push('/dmt');
                                                        history.go();
                                                    }
                                                    if (service == 'mobile' || service == 'recharge') {
                                                        history.push('/recharge');
                                                        history.go();
                                                    }
                                                    if (service == 'billpay') {
                                                        history.push('/billpay');
                                                        history.go();
                                                    }
                                                    if (service == 'aeps') {
                                                        history.push('/aeps');
                                                        history.go();
                                                    }
                                              


                                            }).catch(error => {
                                               
                                                    if (service == '') {
                                                        history.push('/dmt');
                                                        history.go();
                                                    }
                                                    if (service == 'dmt') {
                                                        history.push('/dmt');
                                                        history.go();
                                                    }
                                                    if (service == 'mobile' || service == 'recharge') {
                                                        history.push('/recharge');
                                                        history.go();
                                                    }
                                                    if (service == 'billpay') {
                                                        history.push('/billpay');
                                                        history.go();
                                                    }
                                                    if (service == 'aeps') {
                                                        history.push('/aeps');
                                                        history.go();
                                                    }
                                                
                                            });
                                        } else {
                                            
                                                if (service == '') {
                                                    history.push('/dmt');
                                                    history.go();
                                                }
                                                if (service == 'dmt') {
                                                    history.push('/dmt');
                                                    history.go();
                                                }
                                                if (service == 'mobile' || service == 'recharge') {
                                                    history.push('/recharge');
                                                    history.go();
                                                }
                                                if (service == 'billpay') {
                                                    history.push('/billpay');
                                                    history.go();
                                                }
                                                if (service == 'aeps') {
                                                    history.push('/aeps');
                                                    history.go();
                                                }
                                            
                                        }
                                    } else {
                                       
                                            if (service == '') {
                                                history.push('/dmt');
                                                history.go();
                                            }
                                            if (service == 'dmt') {
                                                history.push('/dmt');
                                                history.go();
                                            }
                                            if (service == 'mobile' || service == 'recharge') {
                                                history.push('/recharge');
                                                history.go();
                                            }
                                            if (service == 'billpay') {
                                                history.push('/billpay');
                                                history.go();
                                            }
                                            if (service == 'aeps') {
                                                history.push('/aeps');
                                                history.go();
                                            }
                                       

                                    }

                                }, 1500);

                            });

                    } else {
                        history.push('/403');
                        history.go();
                    }
                }).catch(error => {
                    if (error.message.includes("401")) {
                        tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                    } else {

                    }
                    console.log(error.message);
                });
            })

        }).catch(err => {
            const deviceInfo = DeviceDetails.fetchDeviceInfo('0.00', '0.00');
            deviceInfo.then((deviceResponse) => {
                store.dispatch(setDeviceInfo(deviceResponse));
                console.log('deviceInfo...' + JSON.stringify(deviceResponse));
                var partnerIdVal = process.env.REACT_APP_PARTNER_ID_ + partner;
                if (partnerIdVal.includes("undefined")) {
                    partnerIdVal = partnerIdVal.substring(9);
                }

                console.log("partnerIdVal", partnerIdVal);

                authorizeRequest = {
                    header: requestHeader,
                    device: deviceResponse,
                    // partnerId:partnerIdVal.trim(),
                    encData: encData

                }

                console.log('request::' + JSON.stringify(authorizeRequest));

                var url = '/api/v1/' + partner + '/user/auth';

                httpClient.post(url, authorizeRequest
                ).then((response) => {
                    console.log('login response' + JSON.stringify(response.data));

                    if (response.data.response.msg == 'SUCCESS') {

                        console.log('login time:', moment().format("DD-MM-YYYY hh:mm:ss"));

                        var token = response.data.token;

                        store.dispatch(setToken(token));
                        store.dispatch(setRequesterId(requesterId));
                        store.dispatch(setLogoName(logo));
                        store.dispatch(setPartner(partner));
                        store.dispatch(setClientRole(role));
                        store.dispatch(setTaLoadPermission(taLoad));
                        store.dispatch(setClaimLoadShow(claimLoadShowVal));
                        store.dispatch(setRetailerBlanceShow(retailerBalanceShowVal));
                        store.dispatch(setTimeoutModal(timeoutModal));
                        store.dispatch(setBillPayShow(showBillPayMenu));

                        store.dispatch(setAgentInfo(response.data.agent));
                        if (
                            response.data.agent.status != null &&
                            response.data.agent.status != undefined &&
                            response.data.agent.status != '') {
                            if (response.data.agent.status == 'SYS_REGISTERED') {
                                store.dispatch(setROId(response.data.agent.internalRoId));
                            }
                        }
                        if (response.data.redirectUrl != undefined &&
                            response.data.redirectUrl != null &&
                            response.data.redirectUrl != '') {
                            store.dispatch(setCallBackUrl(response.data.redirectUrl));
                            store.dispatch(setMiscCallBackUrl(response.data.redirectUrl))
                        } else {
                            if (partner == 'cms') {
                                store.dispatch(setCallBackUrl('/cms-login'));
                                store.dispatch(setMiscCallBackUrl('/cms-login'));
                            }
                            if (partner == 'finxpay') {
                                store.dispatch(setCallBackUrl('/finxpay-login'));
                                store.dispatch(setMiscCallBackUrl('/finxpay-login'));
                            }
                        }


                        //upper case lower case name
                        store.dispatch(setLoginTimestamp(new Date()));
                        // this.readBanklLogo();
                        fetch(process.env.PUBLIC_URL + "/bank_images/bank_logo.txt")
                            .then(data => data.text())
                            .then(data => {
                                store.dispatch(setBankLogoList(data.toUpperCase()));

                                setTimeout(() => {

                                    if (partner == 'finxpay') {

                                        if (response.data.agent.status == null) {
                                            httpClient.post('/agipi/v1/finxpay/user/' + response.data.agent.id + '/assign/' + response.data.agent.id + '/SYS_REGISTERED'
                                                , '',

                                            ).then((response) => {

                                                if (service == '') {
                                                    history.push('/dmt');
                                                    history.go();
                                                }
                                                if (service == 'dmt') {
                                                    history.push('/dmt');
                                                    history.go();
                                                }
                                                if (service == 'mobile' || service == 'recharge') {
                                                    history.push('/recharge');
                                                    history.go();
                                                }
                                                if (service == 'billpay') {
                                                    history.push('/billpay');
                                                    history.go();
                                                }
                                                if (service == 'aeps') {
                                                    history.push('/aeps');
                                                    history.go();
                                                }
                                            }).catch(error => {
                                                if (service == '') {
                                                    history.push('/dmt');
                                                    history.go();
                                                }
                                                if (service == 'dmt') {
                                                    history.push('/dmt');
                                                    history.go();
                                                }
                                                if (service == 'mobile'
                                                    || service == 'recharge') {
                                                    history.push('/recharge');
                                                    history.go();
                                                }
                                                if (service == 'billpay') {
                                                    history.push('/billpay');
                                                    history.go();
                                                }
                                                if (service == 'aeps') {
                                                    history.push('/aeps');
                                                    history.go();
                                                }
                                            });
                                        } else {
                                            if (service == '') {
                                                history.push('/dmt');
                                                history.go();
                                            }
                                            if (service == 'dmt') {
                                                history.push('/dmt');
                                                history.go();
                                            }
                                            if (service == 'mobile' || service == 'recharge') {
                                                history.push('/recharge');
                                                history.go();
                                            }
                                            if (service == 'billpay') {
                                                history.push('/billpay');
                                                history.go();
                                            }
                                            if (service == 'aeps') {
                                                history.push('/aeps');
                                                history.go();
                                            }
                                        }
                                    } else {
                                        if (service == '') {
                                            history.push('/dmt');
                                            history.go();
                                        }
                                        if (service == 'dmt') {
                                            history.push('/dmt');
                                            history.go();
                                        }
                                        if (service == 'mobile' || service == 'recharge') {
                                            history.push('/recharge');
                                            history.go();
                                        }
                                        if (service == 'billpay') {
                                            history.push('/billpay');
                                            history.go();
                                        }
                                        if (service == 'aeps') {
                                            history.push('/aeps');
                                            history.go();
                                        }

                                    }

                                }, 400);

                            });

                    } else {
                        history.push('/403');
                        history.go();
                    }
                }).catch(error => {
                    if (error.message.includes("401")) {
                        tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                    } else {

                    }
                    console.log(error.message);
                });
            })
        });
    }


    componentWillUnmount() {
    }




    render() {

        return (

            <div></div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { otpRefNo, phone, callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, otpRefNo, phone, callBackUrl
});

export default connect(mapStateToProps, null)(Login);
